module.exports = __webpack_public_path__ + "img/20-FCP-articulate-your-new-skills-to-employers.0a011b95.svg";